import { Component } from 'react';
import { withRouter, Route, Switch } from 'react-router-dom';
import { Grid } from '@material-ui/core';

import SidePanel from './SidePanel';
import InstagramFeed from './InstagramFeed';
import YoutubeFeed from './YoutubeFeed';

class Feed extends Component {

  render() {
    return (
      <div style={{ marginTop: 20 }}>
        <div className="inf-hero">
          <div className="inf-hero-inner">
            <p className="inf-hero-kicker">Campaign Performance</p>
            <h1 className="inf-hero-title">Content &amp; Insights</h1>
            <p className="inf-hero-sub">Your posts and how they performed for this campaign.</p>
          </div>
        </div>
        <Grid container spacing={3}>
          <Grid item md={2}>
            <SidePanel />
          </Grid>
          <Grid item md={10}>
            <Switch>
              <Route
                exact
                path={`${this.props.match.url}/youtube`}
                component={() => <YoutubeFeed {...this.props} />}
              />
              <Route
                exact
                path={`${this.props.match.path}/instagram`}
                component={() => <InstagramFeed {...this.props} />}
              />
            </Switch>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withRouter(Feed);
